import React from "react";

export const FormContext = React.createContext<{
  error?: {
    name: string;
    message: string;
  };
}>({});
